module.exports = "<p>{{t('actionWanProtocol.methods.' ~ method)|e}}</p>\n";
